<template>
  <div class="realalarm-container" :class="'isMore' + isMore">
    <div class="top-map">
      <!-- <div v-show="isMore!==2" class="search-view">
        <el-select v-model="curPoint" filterable  clearable :placeholder="$t('operate.name80')" @change="changeMarker">
          <el-option v-for="item in points" :key="item.ebikeId" :label="item.ebikeId" :value="item.ebikeId" />
        </el-select>
      </div> -->
      <div class="maps-change">
        <el-radio-group v-model="mapType" size="mini" @change="changeMap">
          <el-radio-button :label="$t('operate.name74')" />
          <el-radio-button :label="$t('operate.name73')" />
        </el-radio-group>
      </div>
      <div v-if="mapType===$t('operate.name74')" class="map-item">
        <baidu-map class="map" :center="mapCenter" :zoom="mapZoom" :scroll-wheel-zoom='true' @ready="handleMap">
          <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT" />
          <!-- 在地图中添加一个信息窗体 -->
          <bml-marker-clusterer :averageCenter="true">
            <bm-marker
                v-for="item in points"
                :key="item.lng"
                :position="{ lng: item.lng, lat: item.lat}"
                @click="clickMarker(item)"
                :icon="{url: require(item.status===0?'@/assets/bikered.png':'@/assets/bikeblue.png'), size: {width: 50, height: 30},opts: {imageSize: {width: 50,height: 30}}}">
            </bm-marker>
          </bml-marker-clusterer>
          <bm-info-window  :position="{lng: infoWindow?.lng, lat: infoWindow?.lat}" :show="infoWindowShow" @close="closeInfo">
            <div class="infowindow-view">
              <div>{{ $t('bike.name65') }}{{infoWindow?.ebikeId}}</div>
              <div>{{ $t('bike.name295') }}{{infoWindow?.ebikeCode}}</div>
              <div>{{ $t('bike.name492') }}{{infoWindow?.mac}}</div>
              <div>{{ $t('bike.name493') }}{{infoWindow?.tenantName}}</div>
              <div>{{ $t('bike.name168') }}{{infoWindow?.keepliveTime}}</div>
              <div>{{ $t('bike.name171') }}{{infoWindow?.alt}}</div>
              <div v-if="infoWindow?.speed === '--'">{{ $t('bike.name216') }}--</div>
              <div v-else>{{ $t('bike.name216') }}{{Number(infoWindow?.speed / 10).toFixed(1)}}</div>
              <div>{{ $t('bike.name217') }}{{infoWindow?.soc}}</div>
              <div>{{ $t('bike.name494') }}{{[$t('home.name28'), $t('home.name29')][infoWindow?.lockStatus]}}</div>
              <div>{{ $t('bike.name35') }}{{[$t('bike.name113'), $t('bike.name228'), $t('home.name30')][infoWindow?.status] || '--'}}</div>
              <div>{{ $t('bike.name220') }}{{Number(infoWindow?.batteryTemp) + Number(infoWindow?.batteryTemperatureShowDeviation)}}</div>
            </div>
          </bm-info-window>
        </baidu-map>
        <!-- <baidu-map class="hot-map" :center="mapCenterHot" :zoom="mapZoomHot" :scroll-wheel-zoom='true'>
          <bml-heatmap :data="hotmarkersbaidu" :max="maxHot" :radius="20"   />
        </baidu-map> -->
      </div>
      <GmapMap v-else :center="mapCenter" :zoom='mapZoom' class="map-item" ref="mapRef">
      </GmapMap>
    </div>
    <!-- <div class="open-view">
      <el-button v-show="isMore !== 1" icon="el-icon-arrow-down" type="info" size="mini" @click="changeMore(1)"></el-button>
      <el-button v-show="isMore !== 2" icon="el-icon-arrow-up" type="info" size="mini" @click="changeMore(2)"></el-button>
    </div> -->
    <div class="bottom-list">
      <!-- <div class="tabs">
        <div v-for="item in tabs" :key="item.type" class="tabs-item" :class="activeName===item.type?'active':''" @click="handleClick(item)">{{item.label}}（{{item.value}}）</div>
      </div> -->
      <el-table :data="warnList" height="calc(100% - 10px)" :highlight-current-row="true" @row-click="clickMarker">
        <el-table-column :label="$t('finance.name40')" align="center" prop="tenantName" />
        <el-table-column :label="$t('bike.name278')" align="center" prop="ebikeCode" />
        <el-table-column :label="$t('finance.name28')" align="center" prop="ebikeId" />
        <el-table-column :label="$t('bike.name43')" align="center" prop="controllerVersion" />
        <el-table-column :label="$t('bike.name106')" align="center" prop="meterVersion" />
        <el-table-column :label="$t('bike.name107')" align="center" prop="iotVersionNo" />
        <el-table-column :label="$t('home.name26')" align="center" prop="soc" />
        <el-table-column :label="$t('bike.name139')" align="center" prop="batteryTemp">
          <template slot-scope="scope">
            {{ Number(scope.row.batteryTemp) + Number(scope.row.batteryTemperatureShowDeviation)}}
          </template>
        </el-table-column>
        <el-table-column :label="$t('bike.name375')" align="center" prop="createTime" />
        <!--  /车锁的状态  0已解锁  1已上锁-->
        <!-- <el-table-column :label="$t('bike.name225')" align="center" prop="lockStatus">
          <template slot-scope="scope">
            {{[$t('home.name28'), $t('home.name29')][scope.row.lockStatus]}}
          </template>
        </el-table-column> -->
        <el-table-column :label="$t('home.name27')" align="center" prop="status">
          <!--  0：已经坏的  1：正常可用的  2：正在使用的-->
          <template slot-scope="scope">
            {{[$t('bike.name113'), $t('bike.name228'), $t('home.name30')][scope.row.status]}}
          </template>
        </el-table-column>
        <!-- <el-table-column label="历史轨迹" align="center" prop="status">
          <template slot-scope="scope">
            <el-button type="text" @click="showEBikeDetails(scope.row)">查看历史轨迹</el-button>
          </template>
        </el-table-column> -->
      </el-table>
    </div>

     <!--轨迹详情-->
     <el-dialog class="histor-dialog" title="详情轨迹" :visible.sync="historicalTrajectoryDialog" v-if="historicalTrajectoryDialog" :close-on-click-modal ="false" :append-to-body="true" :before-close="close" width="80%">
     <HistoricalTrajectory></HistoricalTrajectory>
    </el-dialog>

  </div>
</template>
<script>
import { BmlMarkerClusterer } from 'vue-baidu-map'
import customMarker from '@/assets/bike.png'
import { mapGetters } from 'vuex'
import coordtransform from 'coordtransform'
import HistoricalTrajectory from '@/components/HistoricalTrajectory'
export default {
  computed: {
    ...mapGetters(['userinfo'])
  },
  props: {
    alarmList: {
      type: Array,
      default: () => []
    }
  },
  components: {
    BmlMarkerClusterer,
    HistoricalTrajectory
  },
  data() {
    return {
      historicalTrajectoryDialog: false,
      map: null,
      BMap: null,
      curPoint: '',
      mapType: this.$t('operate.name74'),
      mapCenter: {
        lng: Math.random() * 40 + 85,
        lat: Math.random() * 30 + 21
      },
      customMarker: customMarker,
      mapZoom: 10,
      mapZoomHot: 1,
      mapCenterHot: {
        lng: 0,
        lat: 0
      },
      infoWindowShow: false,
      infoWindow: null,
      points: [],
      allPoints: [],
      hotmarkersbaidu: [],
      maxHot: 0,
      activeName: 'all',
      tabs: [
        { label: this.$t('home.name23'), type: 'all', typevalue: 2, value: 0 },
        { label: this.$t('home.name24'), type: 'online', typevalue: 1, value: 0 },
        { label: this.$t('home.name25'), type: 'error', typevalue: 0, value: 0 }
      ],
      isMore: 0,
      warnList: [],
      onlineList: [],
      faultList: []
    }
  },
  created() {},
  mounted() {
    // this.getPoints()
  },
  methods: {
    showEBikeDetails() {
      this.historicalTrajectoryDialog = true
    },
    close() {
      this.historicalTrajectoryDialog = false
    },
    addPoints () {
      this.hotmarkersbaidu = []
      for (var i = 0; i < 10; i++) {
        const position = { lng: Math.random() * 40 + 85, lat: Math.random() * 30 + 21, count: parseInt(Math.random() * 10) }
        this.hotmarkersbaidu.push(position)
        if (i === 2) {
          this.mapCenterHot.lng = position.lng
          this.mapCenterHot.lat = position.lat
        }
      }
    },
    changeMore(tag) {
      if (tag === 1) {
        this.isMore = this.isMore === 0 ? 1 : 0
      } else {
        this.isMore = this.isMore === 0 ? 2 : 0
      }
    },
    handleMap({ BMap, map }) {
      this.map = map
      this.BMap = BMap
      this.alarmList.map(item => {
        for (const k in item) {
          if (k !== 'lng' && k !== 'lat' && k !== 'status' && k !== 'lockStatus' && k !== 'batteryTemp' && k !== 'soc') {
            item[k] = item[k] || '--'
          }
        }
      })
      this.warnList = this.alarmList
      if (this.mapType === this.$t('operate.name74')) {
        this.initBaiduMap(this.warnList)
      } else {
        this.initGoogleMap(this.warnList)
      }
    },
    initBaiduMap(dataList) {
      this.hotmarkersbaidu = []
      const hots = new Map()
      this.points = dataList.map((item, index) => {
        if (item.lng) {
          const bikepoints = coordtransform.wgs84togcj02(item.lng, item.lat)
          const bikepointss = coordtransform.gcj02tobd09(bikepoints[0], bikepoints[1])
          item.lng = Number(bikepointss[0])
          item.lat = Number(bikepointss[1])
        } else {
          item.lng = Math.random() * 40 + 85
          item.lat = Math.random() * 30 + 21
        }
        if (!hots.has(`${item.lng},${item.lat}`)) {
          hots.set(`${item.lng},${item.lat}`, { lng: item.lng, lat: item.lat, count: 1 })
        } else {
          hots.set(`${item.lng},${item.lat}`, { lng: item.lng, lat: item.lat, count: hots.get(`${item.lng},${item.lat}`).count + 1 })
        }
        if (index === 0) {
          this.mapCenterHot.lng = item.lng
          this.mapCenterHot.lat = item.lat
        }
        return {
          ...item
        }
      })
      hots.forEach((value, key) => {
        this.hotmarkersbaidu.push(value)
      })
      if (this.hotmarkersbaidu.length > 0) {
        this.maxHot = Math.max(...this.hotmarkersbaidu.map(item => item.count))
      } else {
        this.maxHot = 0
      }
      // this.addPoints()
      // console.log('hotmarkersbaidu', this.hotmarkersbaidu)
      // console.log('hotmarkersbaidu', this.maxHot)
      this.warnList = this.points
      const markers = this.points.map(item => { return { lng: item.lng, lat: item.lat } })
      var view = this.map.getViewport(markers) // markers中包含了所有点
      this.mapZoom = view.zoom // 缩放级别
      this.mapCenter = view.center // 中心点经纬度坐标
    },
    initGoogleMap(dataList) {
      this.points = dataList.map(item => {
        if (item.lng) {
          const bikepoints = coordtransform.wgs84togcj02(item.lng, item.lat)
          item.lng = Number(bikepoints[0])
          item.lat = Number(bikepoints[1])
        } else {
          item.lng = Math.random() * 40 + 85
          item.lat = Math.random() * 30 + 21
        }
        return {
          ...item
        }
      })
      this.warnList = this.points
    },
    changeMap() {

    },
    handleClick(item) {
      this.curPoint = ''
      if (item.type !== this.activeName) {
        this.activeName = item.type
        this.infoWindowShow = false
        this.getPoints()
        // this.mapZoom = 10
        // console.log('=this.activeName==', this.activeName)
        // if (this.activeName === 'all') {
        //   this.warnList = this.allPoints
        // } else if (this.activeName === 'online') {
        //   this.warnList = this.onlineList
        // } else if (this.activeName === 'error') {
        //   this.warnList = this.faultList
        // }
        // console.log('====', item)
        // this.getPoints(item.typevalue)
        // this.warnList = item.typevalue !== '' ? this.points.filter(chi => chi.status === item.typevalue) : this.points
      }
    },
    changeMarker(ebikeId) {
      this.points.map((item) => {
        if (ebikeId === item.ebikeId) {
          this.mapZoom = 20
          this.mapCenter.lng = item.lng
          this.mapCenter.lat = item.lat
          this.infoWindow = item
          setTimeout(() => {
            this.infoWindowShow = true
          }, 100)
        }
      })
    },
    closeInfo() {
      this.infoWindowShow = false
    },
    clickMarker(item) {
      this.mapZoom = 20
      this.infoWindow = item
      setTimeout(() => {
        this.mapCenter.lng = item.lng
        this.mapCenter.lat = item.lat
        this.infoWindowShow = true
      }, 100)
    }
  }
}
</script>
<style lang="scss">
.histor-dialog{
  .el-dialog{
    margin-top: 5vh !important;
  }
}
</style>

<style lang="scss" scoped>
.realalarm-container {
  height: 80vh;
  box-sizing: border-box;
  overflow: hidden;
  .open-view {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    bottom: 40%;
    /*border-top: 1px solid #999;*/
    /*border-bottom: 1px solid #999;*/
    .el-button {
      width: 120px;
      height: 15px;
      line-height: 15px;
      padding: 0;
    }
  }
  .top-map {
    height: 60%;
    position: relative;
    .search-view {
      position: absolute;
      top: 10px;
      left: 10px;
      z-index: 10;
    }
    .maps-change {
      position: absolute;
      top: 20px;
      left: 10px;
      z-index: 10;
    }
    .map-item {
      width: 100%;
      height: 100%;
      position: relative;
      .map {
        width: 100%;
        height: 100%;
      }
      .hot-map {
        position: absolute;
        width: 200px;
        height: 200px;
        bottom: 0;
        right: 0;
        z-index: 10;
        border: 1px solid #000;
      }
    }

  }
  .bottom-list {
    height: 40%;
    .tabs {
      display: flex;
      align-items: center;
      height: 30px;
      padding: 1px 0;
      &-item {
        padding: 0 50px;
        height: 30px;
        line-height: 30px;
        /*border: 1px solid #999;*/
        cursor: pointer;
        &.active {
          /*background: #0f73e6;*/
          color: #0f73e6;
          border-bottom: 1px solid #0f73e6;
        }
      }
    }
    .el-table {
      margin-top: 0 !important;
    }
  }

  &.isMore1 {
    .open-view {
      bottom: 0;
    }
    .top-map {
      height: calc(100%  - 15px);
    }
    .bottom-list {
      height: 0;
    }
  }
  &.isMore2 {
    .open-view {
      bottom: auto;
      top: 0;
    }
    .top-map {
      height: 0;
    }
    .bottom-list {
      height: 100%;
    }
  }
}
  .infowindow-view {
    font-size: 12px;
  }
</style>
<style lang="scss" scoped>

</style>
